import type { AiAppCenterModule } from '../types'

export const liveModule: AiAppCenterModule = {
  key: 'live',
  label: '直播管理',
  desc: '直播创建 / 推流管理 / 互动数据',
  path: '/live',
  homePath: '/live/overview',
  icon: 'ep:video-camera-filled',
  color: '#ff4d4f'
}
